import { render, staticRenderFns } from "./Browser.vue?vue&type=template&id=fbfa0f6e&scoped=true"
import script from "./Browser.vue?vue&type=script&lang=js"
export * from "./Browser.vue?vue&type=script&lang=js"
import style0 from "./Browser.vue?vue&type=style&index=0&id=fbfa0f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfa0f6e",
  null
  
)

export default component.exports